export default "__VITE_ASSET__0a8e429b__"